import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import axios from '../../store/axios-instance';
import * as actions from '../../store/actions';
import EventLanguageModalMobile from '../../Dialogs/EventLanguageModalMobile';
import colors from '../../CSS/_variables.module.scss';
import {ReactComponent as ArrowRightIcon} from '../../Images/svg/arrow_right.svg';
import {ReactComponent as LanguageArrow} from '../../Images/svg/languageArrow.svg';
import {preventDefaultDrag} from '../../Utils/utils';

class EventLanguage extends PureComponent {
    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        const {languages} = props;
        const sortedLanguages = [];

        languages.platformLanguages.map((item) => {
            return sortedLanguages.push(item.value);
        });

        this.state = {
            showLanguageList: false,
            listLanguages: sortedLanguages.sort(),
            openSelectLanguage: false,
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    toggleShowLanguageList = () =>
        this.setState((prevState) => ({
            showLanguageList: !prevState.showLanguageList,
        }));

    handleOpenSelectLanguageDialog = () =>
        this.setState({
            openSelectLanguage: true,
        });

    handleCloseSelectLanguageDialog = () =>
        this.setState({
            openSelectLanguage: false,
        });

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showLanguageList: false,
            });
        }
    }

    handleChangeLanguage = (languageCode) => () => {
        const {onSetPlatformLanguage, onRefreshUserData} = this.props;
        axios({method: 'put', url: '/users', data: {language: languageCode}})
            .then(() => {
                onSetPlatformLanguage(languageCode);
                onRefreshUserData();
            })
            .catch(() => {});
        this.setState({
            showLanguageList: false,
            openSelectLanguage: false,
        });
    };

    handleEnterKey = (tab, language) => (e) => {
        if (e.key === 'Enter') {
            if (tab === 'tab')
                return this.setState((prevState) => ({
                    showLanguageList: !prevState.showLanguageList,
                }));

            if (tab === 'list') return this.handleChangeLanguage(language)();
        }
    };

    render() {
        const {showLanguageList, listLanguages, openSelectLanguage} = this.state;
        const {languages, isMobile, isTablet, translation} = this.props;

        return (
            <>
                <div
                    tabIndex="0"
                    onDragStart={preventDefaultDrag}
                    className="select-language-container"
                    ref={this.setWrapperRef}
                    onKeyDown={this.handleEnterKey('tab')}
                >
                    {isMobile || isTablet ? (
                        <div
                            onDragStart={preventDefaultDrag}
                            className="selected-language"
                            onClick={this.handleOpenSelectLanguageDialog}
                        >
                            <h4>
                                {translation?.myAccountPage.platformLanguage} <span>{languages.platformLanguage}</span>
                            </h4>
                            <div>
                                <ArrowRightIcon
                                    width="24"
                                    height="24"
                                    fill={colors.greyDark}
                                    className="arabic-rotate"
                                />
                            </div>
                        </div>
                    ) : (
                        <div
                            onDragStart={preventDefaultDrag}
                            className="selected-language"
                            onClick={this.toggleShowLanguageList}
                        >
                            <span>{languages.platformLanguage}</span>
                            <LanguageArrow />
                        </div>
                    )}
                    {showLanguageList && (
                        <div onDragStart={preventDefaultDrag} className="languages-list-container">
                            <ul>
                                {listLanguages.map((language) => {
                                    return (
                                        <li
                                            tabIndex="0"
                                            key={language}
                                            value={language}
                                            onClick={this.handleChangeLanguage(language)}
                                            onKeyDown={this.handleEnterKey('list', language)}
                                            className={`${language === languages.platformLanguage ? 'active' : ''}`}
                                        >
                                            {language}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </div>
                <EventLanguageModalMobile
                    open={openSelectLanguage}
                    languages={languages}
                    handleChangeLanguage={this.handleChangeLanguage}
                    handleCloseSelectLanguageDialog={this.handleCloseSelectLanguageDialog}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.data,
        eventMatching: state.organizer.eventMatching,
        eventId: state.event.eventId,
        languages: state.languages,
        isMobile: state.layout.isMobile,
        isTablet: state.layout.isTablet,
        translation: state.languages.translations[state.languages.platformLanguage],
        defaultTranslation: state.languages.translations['en'],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onRefreshUserData: () => dispatch(actions.refreshUserData()),
        onSetPlatformLanguage: (languageCode) => dispatch(actions.setPlatformLanguage(languageCode)),
        onRecalculateUserMatchingScore: (eventId, questionnaireId) =>
            dispatch(actions.recalculateUserMatchingScore(eventId, questionnaireId)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventLanguage));
